import React, { PureComponent } from 'react';

import classNames from 'classnames';
import TooltipPortal from 'components/tooltip/TooltipPortal';
import PropTypes from 'prop-types';

import { I18n } from '../../translate';

import './CanvasMenuButton.scss';

export default class CanvasMenuButton extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    label: PropTypes.string,
    toolTip: PropTypes.string,
    active: PropTypes.bool,
    icon: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    label: '',
    active: false,
    toolTip: '',
    icon: '',
    disabled: false
  };

  onClick = () => {
    const { onClick, disabled } = this.props;
    const clickable = onClick && !disabled;

    clickable && onClick();
  };

  render() {
    const { label, toolTip, active, icon, className, disabled } = this.props;
    const toolTipId = toolTip || label || icon;
    let buttonClassName = classNames(
      'canvas-menu__button',
      { 'canvas-menu__button--active': active },
      className
    );

    buttonClassName = classNames(buttonClassName, {
      'canvas-menu__button--disabled': disabled
    });

    return (
      <div
        id={`canvas-menu-button__${toolTipId}`}
        onClick={this.onClick}
        className={buttonClassName}
      >
        {toolTip && (
          <TooltipPortal parentId={`canvas-menu-button__${toolTipId}`}>
            <I18n label={toolTip} />
          </TooltipPortal>
        )}
        {icon && <i className={`icon icon-${icon}`} />}
        {label && (
          <span>
            <I18n label={label} />
          </span>
        )}
      </div>
    );
  }
}
